<style  lang="less" scoped>
.navbar {
  height: 64px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 0px !important;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  position: relative;
  z-index: 999;
  .hamburger-container {
    transition: all 0.3s, padding 0s;
    padding: 0 24px;
    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }
  .right-menu {
    &:focus {
      outline: none;
    }
    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
    }
    .username {
      vertical-align: 12px;
      color: #333;
      font-size: 14px;
    }
    .avatar-container {
      margin-right: 30px;
      .avatar-wrapper {
        cursor: pointer;
      }
    }
  }
}
</style>

<template>
  <div>
    <div class="navbar">
      <hamburger :toggle-click="toggleSideBar" :is-active="sidebar.opened" class="hamburger-container" />

      <div class="right-menu">
        <el-dropdown class="avatar-container right-menu-item" trigger="hover">
          <div class="avatar-wrapper">
            <span class="username right-menu-item">{{user.name}}</span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <span style="display:block;" @click="changePassword">修改密码</span>
            </el-dropdown-item>
            <el-dropdown-item divided>
              <span style="display:block;" @click="logout">退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="400px">
      <el-form :model="passwordForm">
        <el-form-item label="当前密码" :label-width="formLabelWidth">
          <el-input type="password" v-model="passwordForm.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" :label-width="formLabelWidth">
          <el-input type="password" v-model="passwordForm.newPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码确认" :label-width="formLabelWidth">
          <el-input type="password" v-model="passwordForm.newPasswordAg" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updatePassword">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Hamburger from '@/components/Hamburger'

export default {
  components: {
    Hamburger
  },
  data: () => ({
    dialogFormVisible: false,
    formLabelWidth: 'auto',
    passwordForm: {
      password: '',
      newPassword: '',
      newPasswordAg: ''
    }
  }),
  computed: {
    ...mapState('app', {
      sidebar: state => state.sidebar,
      device: state => state.device,
    }),
    ...mapState('auth', {
      user: state => state.currentUser || {}
    })
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$confirm('确定退出当前账号', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      await this.$store.dispatch('auth/logout')
      this.$router.replace({ name: 'login' })
    },
    changePassword() {
      this.dialogFormVisible = true
    },
    async updatePassword() {
      const { password, newPassword, newPasswordAg } = this.passwordForm
      if (!password || !newPassword) {
        this.$message.error('请填写密码')
        return
      }
      if (newPassword.length < 6) {
        this.$message.error('请填写6位数及以上的密码')
        return
      }
      if (newPassword != newPasswordAg) {
        this.$message.error('密码确认不一致')
        return
      }
      await this.$store.dispatch('auth/update', { password, newPassword })
      this.$message.success('密码修改成功')
      this.dialogFormVisible = false
    }
  }
}
</script>

